/** Ce qu'un groupe d'onglets multilingues laisse dans le formulaire : une entrée par langue montrée,
 * y compris celles que personne n'a remplies. */
type TranslatableFormValue = Partial<Record<LanguageKey, { value?: string } | undefined>>;

/**
 * Traduit la valeur d'un champ multilingue en ce que l'API attend.
 *
 * Une langue vide part en `null` — « pas de traduction » — et non en `{ value: '' }`, que l'API
 * rejette. Sans ça, saisir le français suffit à faire échouer la requête : les onglets des autres
 * langues sont montés eux aussi, et laissent leur chaîne vide dans le formulaire.
 */
export default function toTranslationsPayload(value: TranslatableFormValue) {
	return Object.entries(value).reduce<Partial<Record<LanguageKey, { value: string } | null>>>(
		(acc, [lang, translation]) => {
			acc[lang as LanguageKey] = translation?.value ? { value: translation.value } : null;
			return acc;
		},
		{},
	);
}
